import React from "react";
import {
  Box,
  Stack,
  FormControl,
  OutlinedInput,
  Typography,
  Divider,
} from "@mui/material";
import "./index.scss";
export default function SikiInput({
  label,
  icon,
  placeholder,
  value,
  onChange,
  width,
  left,
}) {
  const [val, setVal] = React.useState(value);
  return (
    <FormControl
      className="__form_control"
      style={{ width: width ? width : "100%" }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        {label ? (
          <Typography
            className={"__label"}
            variant="body1"
            style={{ marginLeft: left ? left : "", marginBottom: "5px" }}
          >
            {label}
          </Typography>
        ) : null}
      </Stack>

      <Box className="__social_inputbox">
        {icon ? icon : null}

        <OutlinedInput
          sx={{ width: "100%" }}
          value={val}
          onChange={(e) => {
            setVal(e.target.value);
            onChange(e.target.value);
          }}
          className="__input"
          placeholder={placeholder}
        />
      </Box>
    </FormControl>
  );
}
